<template>
  <div class="map-picker">
    <button v-if="onlyButton && !value"
            type="button"
            class="map-picker__btn"
            style="position: static; margin: 0"
            @click.prevent="onShowPopup"
    >
      <BaseSvg name="ico-dot-map"
               width="1.7rem"
               height="1.7rem"/>
      <span>
        {{ $tNewVacancy2('Show on the map') }}
      </span>
    </button>
    <div v-else
         class="map-picker__input-wrap">
      <BaseInput v-bind="$attrs"
                 :value="value"
                 @input="$emit('input', $event)"
                 :class="error ? '_error' : null"
                 :disabled="onlyButton"
                 class="map-picker__input"/>
      <button type="button"
              class="map-picker__btn"
              @click.prevent="onShowPopup"
      >
        <BaseSvg name="ico-dot-map"
                 width="1.7rem"
                 height="1.7rem"/>
        <span>
          {{ $tNewVacancy2('Show on the map') }}
        </span>
      </button>
    </div>
    <InputError :value="error"/>

    <transition name="fade">
      <div v-if="showPopup"
           class="map-picker__popup">
        <button type="button"
                class="map-picker__popup-close"
                @click.prevent="onClosePopup">
          <BaseSvg name="ico-close"/>
        </button>
        <GmapMap
          ref="mapRef"
          :center="{lat: initPos.lat, lng: initPos.lng}"
          :zoom="10"
          :options="mapOptions"
          class="map-picker__popup-map"
          @click="onClickMap"
        >
          <GmapMarker
            ref="markerRef"
            :position="{lat: initPos.lat, lng: initPos.lng}"
            :draggable="true"
            :icon="{url: markerIcon, scaledSize: {width: 28, height: 40}}"
          />
        </GmapMap>
        <div class="map-picker__popup-footer">
          <div class="map-picker__zoom">
            <button type="button"
                    class="map-picker__zoom-btn base-btn base-btn--small"
                    @click.prevent="zoomOut"
            >
              <BaseSvg name="ico-minus"/>
            </button>
            <button type="button"
                    class="map-picker__zoom-btn base-btn base-btn--small"
                    @click.prevent="zoomIn"
            >
              <BaseSvg name="ico-plus"/>
            </button>
          </div>

          <button type="button"
                  class="map-picker__btn-apply base-btn  base-btn--outline-grey-green  base-btn--small"
                  @click.prevent="onApply"
          >
            <BaseSvg name="ico-check"
                     width="1.2rem"
                     height="1.2rem"/>
            <span class="base-btn__text">
              {{ $tNewVacancy2('Confirm') }}
            </span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import InputError from '../BaseInputError'

  if (!Vue.prototype._mapInstaled) {
    Vue.use(VueGoogleMaps, {
      load: {
        key: 'AIzaSyDm1YdV9T77SBSzvZO93XXg6zwiwqtgrjI',
        libraries: 'places' // This is required if you use the Autocomplete plugin
      }
    })

    Vue.prototype._mapInstaled = true
  }

  export default {
    name: 'MapPicker',
    components: {
      InputError
    },
    props: {
      value: String,
      onlyButton: {
        type: Boolean,
        default: false
      },
      error: {
        type: [String, Array]
      },
    },
    data() {
      return {
        showPopup: false,
        initPos: {
          lat: 50.445869,
          lng: 30.5601309
        },
        isChosen: false,
        newPos: {},
        currentZoom: 10,
        markerIcon: require('../../assets/img/svg/map-marker.svg'),
        mapOptions: {
          disableDefaultUi: true,
          zoomControl: false,
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false
        }
      }
    },
    methods: {
      onShowPopup() {
        this.showPopup = true

        if (!this.isChosen && navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {

            this.newPos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }

            this.$refs.mapRef.$mapPromise.then((map) => {
              map.panTo(this.newPos)
            })

            this.$refs.markerRef.$markerPromise.then((marker) => {
              marker.setPosition(this.newPos)
            })
          })
        }
      },
      onClickMap(e) {
        this.newPos = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        }
        this.$refs.markerRef.$markerPromise.then((marker) => {
          marker.setPosition(this.newPos)
        })
      },
      zoomOut() {
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.currentZoom = map.getZoom()
          if (this.currentZoom > 1) {
            map.setZoom(this.currentZoom - 1)
          }
        })
      },
      zoomIn() {
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.currentZoom = map.getZoom()
          if (this.currentZoom < 21) {
            map.setZoom(this.currentZoom + 1)
          }
        })
      },
      onClosePopup() {
        this.showPopup = false
      },
      onApply() {
        this.$refs.markerRef.$markerPromise.then((marker) => {
          const api = VueGoogleMaps.gmapApi()

          const geocoder = new api.maps.Geocoder()

          this.newPos = {
            lat: parseFloat(marker.getPosition().lat()),
            lng: parseFloat(marker.getPosition().lng())
          };

          geocoder.geocode({ location: this.newPos }, (results, status) => {
            if (status === "OK") {
              if (results[0]) {
                this.$emit('input', results[0].formatted_address)
              } else {
                console.log("No results found");
              }
            } else {
              console.log("Geocoder failed due to: " + status);
            }
          });
          this.onClosePopup()
          this.isChosen = true
          this.initPos = this.newPos
        })
      },
    }
  }
</script>

<style>

</style>
